import React, { ReactNode, ReactElement } from 'react'
import { GoogleOAuthProvider } from '@react-oauth/google'
// import { MicrosoftProvider } from '@microsoft/mgt-react';

type GoogleProviderProps = {
  clientId: string
}

// type MicrosoftProviderProps = {
//   clientId: string;
//   scopes: string[];
// };

type ProviderConfig = { type: 'google'; props: GoogleProviderProps }
// | { type: 'microsoft'; props: MicrosoftProviderProps }

interface AuthProvidersProps {
  children: ReactNode
  providers: ProviderConfig[]
}

const AuthProviders = ({ children, providers }: AuthProvidersProps): ReactElement => {
  const nestProviders = (
    remainingProviders: ProviderConfig[],
    nestedChildren: ReactNode
  ): ReactElement => {
    if (remainingProviders.length === 0) {
      // Need to cast children to ReactElement or return a fragment containing children
      return <>{nestedChildren}</>
    }

    const [current, ...rest] = remainingProviders

    switch (current.type) {
      case 'google':
        return (
          <GoogleOAuthProvider clientId={current.props.clientId}>
            {nestProviders(rest, nestedChildren)}
          </GoogleOAuthProvider>
        )
      // case 'microsoft':
      //   return (
      //     <MicrosoftProvider clientId={current.props.clientId} scopes={current.props.scopes}>
      //       {nestProviders(rest, nestedChildren)}
      //     </MicrosoftProvider>
      //   );
      default:
        return nestProviders(rest, nestedChildren)
    }
  }

  return nestProviders(providers, children)
}

export default AuthProviders
